export default "__VITE_ASSET__BxW9jJI7__"